import React, { useEffect, useState } from 'react';
import { FirebaseRemoteConfig } from '../../utils/FirebaseRemoteConfig';
import { Logger } from '../../utils/Logger';

export const AbExperimentVariant = ({ remoteConfigKey, value, children }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  useEffect(() => {
    async function getVariantEnabled() {
      const isVariantEnabled =
        await FirebaseRemoteConfig.abExperimentVariantEnabled(
          remoteConfigKey,
          value,
        );
      setIsEnabled(isVariantEnabled);
    }
    getVariantEnabled()
      .catch((e) => Logger.notify(e));
  }, []);
  return isEnabled ? <>{children}</> : <></>;
};
